import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import React from "react";
import Icon from "../Icon/component";
import Preloader from "../Preloader/component";
import { useSingleMediaDropdoze } from "./hooks";
import "./style.less";
import { type InputProps, type RootProps, type UploadSingleMediaPropsBase } from "./types";
import withDropzone, { type WithDropzoneComponentProps } from "./withDropzone";

export type UploadDndFileChildrenArgs = {
  isUploading: boolean;
  rootProps: RootProps;
  inputProps: InputProps;
  progress: number;
};
type Props<T extends object> = UploadSingleMediaPropsBase<T> & {
  children?: (args: UploadDndFileChildrenArgs) => any;
  isNoPreloader?: boolean;
};
const UploadDndFile = withDropzone(<T extends object>(props: Props<T> & WithDropzoneComponentProps) => {
  const i18n = useI18n();

  const { isUploading, getRootProps, getInputProps } = useSingleMediaDropdoze(props);

  if (props.children) {
    return props.children({
      isUploading,
      progress: 0,
      rootProps: getRootProps(),
      inputProps: getInputProps()
    });
  }

  return (
    <div className="dnd_file_upload" {...getRootProps()} data-name={props.qa}>
      <input {...getInputProps()} />
      {!props.isNoPreloader && isUploading ? (
        <Preloader relative={false} type="spinner" />
      ) : (
        <>
          <Icon icon={IconType.FileDownloadLight} />
          <span className="message">{i18n.dropToUpload}</span>
        </>
      )}
    </div>
  );
}) as <T extends object>(props: Props<T>) => any;
export default UploadDndFile;
